/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Agent_Builder_Max_Steps_RangeInputs */



/**
* | output |
* | --- |
* | "Enter a number between {min} and {max}." |
*
* @param {Agent_Builder_Max_Steps_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_max_steps_range = /** @type {((inputs: Agent_Builder_Max_Steps_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Max_Steps_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitte eine Zahl zwischen ${i?.min} und ${i?.max} eingeben.`)
	return /** @type {LocalizedString} */ (`Enter a number between ${i?.min} and ${i?.max}.`)
});